import React from "react";
import { useNavigate } from "react-router-dom";

import { ActualFundType } from "@constants/funds-data";

interface Props {
  dataRow: ActualFundType;
}

export const FundsTableRow = ({ dataRow }: Props) => {
  const navigate = useNavigate();

  // Decode hex name to readable string
  // Fund name structure: first 16 hex chars (8 bytes) = fund name, rest is hash
  const decodeHex = (hex: string) => {
    try {
      // Take only first 16 hex characters (8 bytes) for the fund name
      const nameHex = hex.substring(0, 16);
      let str = '';
      for (let i = 0; i < nameHex.length; i += 2) {
        str += String.fromCharCode(parseInt(nameHex.substring(i, i + 2), 16));
      }
      return str;
    } catch {
      return hex;
    }
  };

  const decodedName = dataRow.fund_name || (dataRow.name ? decodeHex(dataRow.name) : 'Unknown Fund');
  // Use the hex name as the fund ID since it's unique
  const fundId = dataRow.name;

  const handleRowClick = () => {
    navigate("/details/" + fundId, { state: dataRow });
  };

  return (
    <>
      <tr
        className="relative transition-all duration-200 md:hover:bg-violet-50 md:hover:dark:bg-gray-800 cursor-pointer"
        onClick={handleRowClick}
      >
        <td className="bg-gradient-to-r from-white dark:from-gray-900 via-white dark:via-gray-900 to-opacity-0 md:bg-none sticky -left-0.5 z-10 pl-1 md:p-0 md:static px-14 md:rounded-l-md">
          <div className="flex items-center justify-center py-[2px]">
            <div className="w-10 h-10 rounded-full bg-violet-700 flex items-center justify-center font-bold font-sf-pro text-white text-base">
              {dataRow.tokens.length}
            </div>
          </div>
        </td>
        <td className="px-4 md:rounded-l-md relative">
          <div className="flex items-center gap-3">
            <span className="text-gray-800 text-m md:text-xl font-medium dark:text-white whitespace-nowrap">
              {decodedName}
            </span>
          </div>
        </td>
        <td className="text-gray-800 text-m md:text-l font-medium text-right dark:text-white pr-12px md:rounded-r-md">
          {((dataRow.royalty_factor / dataRow.fund_factor) * 100).toFixed(2)}%
        </td>
      </tr>
    </>
  );
};
